import i18n from "../../../../../../constants/i18n";
import Et3Image from "../../../../../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../../core/et3-div";
import { CAMERA_SOLID } from "../../../../../../constants/picker-entries-constants";

const UserImageBanner = withLiteObserverAndTheme<{ currentSource: string }>(
  (props) => {
    const { theme, currentSource } = props;
    const { colors } = theme;

    return currentSource === CAMERA_SOLID ? (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={true}
        width={224}
        height={224}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.lightGray}
        style={{
          borderRadius: 10
        }}
        onClick={() => {}}
      >
        <Et3Image
          type="LOCAL"
          alt={i18n.get("USER")}
          imageName={CAMERA_SOLID}
          size={93}
          onClick={() => {}}
          style={{
            borderRadius: 10
          }}
        />
      </ET3Div>
    ) : (
      <Et3Image
        type="ONLINE"
        alt={i18n.get("USER")}
        imageName={currentSource}
        size={224}
        onClick={() => {}}
        style={{
          borderRadius: 10
        }}
      />
    );
  }
);
export default UserImageBanner;
